import { useState } from 'react';

export const BonusCalculator: React.FC = () => {
  const [deposit, setDeposit] = useState(50);
  const matchPercent = 100;
  const maxBonus = 100;
  const wagering = 35;

  const bonusAmount = Math.min(deposit * (matchPercent / 100), maxBonus);
  const totalBalance = deposit + bonusAmount;
  const wageringRequirement = totalBalance * wagering;

  return (
    <div className="glass-card p-6">
      <h3 className="text-2xl font-bold text-primary-green mb-4">Bonus Calculator</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Deposit Amount: £{deposit}
          </label>
          <input
            type="range"
            min="10"
            max="500"
            value={deposit}
            onChange={(e) => setDeposit(Number(e.target.value))}
            className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-primary-green"
          />
          <div className="flex justify-between text-xs text-gray-400 mt-1">
            <span>£10</span>
            <span>£500</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-primary-green/30">
          <div>
            <p className="text-sm text-gray-400">Bonus Amount</p>
            <p className="text-2xl font-bold text-primary-green">£{bonusAmount.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-sm text-gray-400">Total Balance</p>
            <p className="text-2xl font-bold text-white">£{totalBalance.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-sm text-gray-400">Wagering Required</p>
            <p className="text-2xl font-bold text-accent-red">£{wageringRequirement.toFixed(2)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

